import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from '@core/layout/component/main-layout/main-layout.component';
import { PreAuthLayoutComponent } from '@core/layout/component/pre-auth-layout/pre-auth-layout.component';
import { authGuard } from '@shared/guard/auth.guard';
import { IsNotAdminGuard } from '@shared/guard/is-not-admin.guard';
import { isAdminOrSuperUserGuard } from '@shared/guard/is-admin-or-super-user.guard';
import { isNotAdminAndSuperUserGuard } from '@shared/guard/is-not-admin-and-super-user-guard';

const routes: Routes = [
  {
    path: '', component: MainLayoutComponent,
    canActivate: [ authGuard ],
    children: [
      { path: '', loadChildren: () => import('./view/dashboard/dashboard-routes').then(m => m.routes), canActivate: [ isNotAdminAndSuperUserGuard ] },
      {
        path: 'usefull-links',
        loadChildren: () => import('./view/usefull-links/usefull-links-routes').then(m => m.routes)
      },
      {
        path: 'calendar',
        loadChildren: () => import('./view/calendar/calendar-routes').then(m => m.routes),
        canActivate: [ IsNotAdminGuard ]
      },
      {
        path: 'inbox',
        loadChildren: () => import('./view/inbox/inbox-routes').then(m => m.routes),
        canActivate: [ IsNotAdminGuard ]
      },
      {
        path: 'log-book',
        loadChildren: () => import('./view/log-book/log-book-routes').then(m => m.routes),
        canActivate: [ IsNotAdminGuard ]
      },
      {
        path: 'patients',
        loadChildren: () => import('./view/patients/patients-routes').then(m => m.routes),
      },
      {
        path: 'self-help-library',
        loadChildren: () => import('./view/self-help-library/self-help-library.routes').then(m => m.routes)
      },
      {
        path: 'health-monitor',
        loadChildren: () => import('./view/patients/health-monitor-details-routes').then(m => m.routes),
        canActivate: [ IsNotAdminGuard ]
      },
      {
        path: 'team',
        canActivate: [ isAdminOrSuperUserGuard ],
        loadChildren: () => import('./view/team/team-routes').then(m => m.routes)
      },
      {
        path: 'buddy-groups',
        canActivate: [ isAdminOrSuperUserGuard ],
        loadChildren: () => import('./view/buddy-groups/buddy-groups-routes').then(m => m.BUDDY_GROUPS_ROUTES)
      },
      {
        path: 'timeout',
        loadChildren: () => import('./view/timeout/timeout-routes').then(m => m.routes)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./view/notifications/notifications.routes').then(m => m.routes)
      }
    ]
  },
  {
    path: 'auth', component: PreAuthLayoutComponent,
    loadChildren: () => import('app/view/auth/auth-page.module').then(m => m.AuthPageModule)
  },
  {
    path: 'error',
    loadChildren: () => import('app/view/error/error-page.module').then(m => m.ErrorPageModule)
  },
  { path: '**', redirectTo: 'error/not-found' }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', scrollPositionRestoration: 'enabled' }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {
}
